import * as types from '../mutation-types'

const defaultReleasesState = () => {
  return {
    releases: {},
    releasesOrder: [],

    currentPage: 0,
    totalCount: 0,
  }
}

export const mutations = {
  [types.CLEAR_RELEASES] (state) {
    Object.assign(state, defaultReleasesState())
  },
  [types.RECEIVE_FIRST_RELEASES] (state, params) {
    state.releases = params.releases
    state.releasesOrder = params.releasesOrder
    state.totalCount = params.totalCount
    state.currentPage = 1
  },
  [types.RECEIVE_NEXT_RELEASES] (state, params) {
    state.releases = { ...state.releases, ...params.releases }
    state.releasesOrder.push(...params.releasesOrder)
    state.currentPage++
  },
}

const module = HTTP => ({
  state: defaultReleasesState(),
  mutations,
  actions: {
    async getFirstReleases ({ commit }, params) {
      try {
        commit(types.CLEAR_RELEASES)

        const response = await HTTP.get(`/sources/${params.sourceId}/packages/${params.packageName}/releases`)
        const releases = response.data.releases
        const releasesOrder = response.data.releases_order

        const count = response.headers['x-total-count'] || 1
        commit(types.RECEIVE_FIRST_RELEASES, { releases: releases, releasesOrder: releasesOrder, totalCount: +count })
      } catch (e) {
        console.log(e)
      }
    },
    async getNextReleases ({ commit, state }, params) {
      try {
        const response = await HTTP.get(`/sources/${params.sourceId}/packages/${params.packageName}/releases?_page=${state.currentPage + 1}`)
        const releases = response.data.releases
        const releasesOrder = response.data.releases_order

        commit(types.RECEIVE_NEXT_RELEASES, { releases: releases, releasesOrder: releasesOrder })
      } catch (e) {
        console.log(e)
      }
    },
  },
})

export default {
  module,
}
